const initialState = {
    isOpen: false,
}

const assetUpdateDialogReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_ASSET_UPDATE_DIALOG':
            return {
                ...state,
                isOpen: true,
            }

        case 'HIDE_ASSET_UPDATE_DIALOG':
            return {
                ...state,
                isOpen: false,
            }

        default:
            return state
    }
}

export default assetUpdateDialogReducer
